<template>
  <el-dialog
    :model-value="dialogFlag"
    title="微信扫码付款"
    :center="true"
    :close-on-click-modal="false"
    @close="$emit('closeDialog')"
  >
    <vue-qr
      class="code-img"
      :text="content"
      :size="240"
      :logoSrc="require('/src/assets/images/logo.png')"
    ></vue-qr>
    <span v-if="platform=='wechat'"><b>&nbsp;&nbsp;&nbsp;&nbsp;请长按二维码，并在弹窗后点击"识别图中的二维码"完成支付。</b></span>
    <br />
    <span style="text-ident:2rem;"><b>&nbsp;&nbsp;&nbsp;&nbsp;付款完成后会自动开启生成报告，请注意生成报告时间大约5分钟，生成报告期间请勿关闭程序和网页，生成完后自动开始下载，有疑问请联系客服。</b></span>
  </el-dialog>
</template>
<script>
import { ElDialog } from "element-plus";
import vueQr from "vue-qr/src/packages/vue-qr.vue";
export default {
  name: "PruchaseDialog",
  data() {
    return {
      platform: this.checkPlatform()
    };
  },
  emits: ['closeDialog'],
  props: {
    dialogFlag: {
      type: Boolean
    },
    content: {
      type: String,
      default() {
        return undefined;
      },
    },
  },
  components: { ElDialog, vueQr }
};
</script>
<style lang="less">
  .el-overlay {
    background-color: rgba(0,0,0,.95) !important;
  }
  .el-dialog {
    max-width: 360px !important;
  }
  .code-img {
    display: block;
    margin: auto;
    width: 100%;
  }
</style>
